export default "__VITE_ASSET__288c08ac__"